import { StrictMode, useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider, createTheme, useMediaQuery } from '@mui/material';
import { AuthProvider } from './auth';
import { App } from './App';

function Themed({ children }: { children: React.ReactNode }) {
  // Follows the OS rather than forcing a mode — this sits open beside a charting app
  // that is already dark most of the day.
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useMemo(
    () =>
      createTheme({
        palette: { mode: prefersDark ? 'dark' : 'light', primary: { main: '#0e6f62' } },
        shape: { borderRadius: 6 },
        typography: { fontSize: 14 },
      }),
    [prefersDark],
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Themed>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Themed>
  </StrictMode>,
);
